import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-politique-confidentialite',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './politique-confidentialite.component.html',
  styleUrl: './politique-confidentialite.component.scss'
})
export class PolitiqueConfidentialiteComponent implements OnInit {
  title = 'Politique de Confidentialité';
  subtitle = 'Protection et traitement de vos données personnelles conformément au RGPD';
  heroImage = 'assets/static_pages_images/rc.jpg';
  breadcrumbs = [
    { label: 'Legal', url: undefined },
    { label: 'Politique de Confidentialité', url: undefined }
  ];
  prevPage = {
    title: 'Mentions Légales',
    link: '/mentions-legales'
  };
  nextPage = {
    title: 'Conditions Générales de Vente',
    link: '/cgv'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToContact(): void {
    this.router.navigate(['/contact']);
  }
}
